import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const DOCS_ECONSENT_LANG: {
  CANCEL_ECONSENT_TOOLTIP_CONTENT: MvnCodeFE;
  CANCEL_ECONSENT_DIALOG_TITLE: MvnCodeFE;
  NTH_SIGNER_LABEL: MvnCodeFE;
} = {
  CANCEL_ECONSENT_TOOLTIP_CONTENT: {
    ko: "전자 동의서 요청 취소",
    en: "Cancel eConsent Request",
  },
  CANCEL_ECONSENT_DIALOG_TITLE: {
    ko: "전자 동의서 요청 취소",
    en: "Cancel eConsent Request",
  },
  NTH_SIGNER_LABEL: {
    ko: "서명자",
    en: "Signee",
  },
};

MvnCodeInitiate(DOCS_ECONSENT_LANG);
